import FolderIconGrey from '@Resources/assets/icons/dark/folderSmGrey.svg';
import Flex from '@Resources/styles/flex.scss';
import ColorsStyles from '@Styles/colors.scss';
import { GridRowProps } from '@mui/x-data-grid';
import cx from 'classnames';
import _isNil from 'lodash/isNil';
import { Color } from 'maplibre-gl';
import React, { useState } from 'react';
import { IconButton } from '@Components/IconButton';
import Styles from './Folders.scss';
import QcSnapshotFolderMenu from './QcSnapshotFolderMenu';

interface IQcSnapshotFolderOptionProps {
    name: string;
    qcFolderId: string;
    numberPoles: number;
    onClick: () => void;
}

const QcSnapshotFolderOption = (props: IQcSnapshotFolderOptionProps) => {
    const { name, qcFolderId, numberPoles, onClick } = props;

    return (
        <div
            id={`${qcFolderId}-container`}
            className={cx(
                Flex.flex,
                Flex.justifyBetween,
                Styles.fullFolderContainer,
                Styles.qcFoContainer
            )}
        >
            <div className={Styles.folderOptionContainer}>
                <div
                    className={cx(
                        Flex.flex,
                        Flex.justifyBetween,
                        Styles.fullFolderContainer
                    )}
                    onClick={onClick}
                >
                    <div className={Styles.foLeftContainer}>
                        <FolderIconGrey />
                        <span
                            className={Styles.folderNumPoles}
                            style={{
                                color: ColorsStyles.ikeGradient8,
                                marginTop: '2px',
                            }}
                        >
                            {numberPoles}
                        </span>
                        <span
                            id={`${qcFolderId}-title`}
                            className={Styles.foTitle}
                            style={{ color: ColorsStyles.ikeGradient8 }}
                        >
                            {name}
                        </span>
                    </div>
                    <QcSnapshotFolderMenu
                        id={`${qcFolderId}-qc-folder-menu`}
                        folderId={qcFolderId}
                    />
                </div>
            </div>
        </div>
    );
};

export default QcSnapshotFolderOption;
